module.exports = [{
      plugin: require('D:/WebApps/gatsby-tril/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('D:/WebApps/gatsby-tril/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
